import * as React from 'react';
import noneImg from '@images/web/allIcon.png';
interface Props {
  text: string,
}
const NoneData: React.FC<Props> = props => (
  <div
    style={
      {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%) ',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }
    }
  >
    <i
      style={{
        display: 'block',
        width: '33px',
        height: '34px',
        background: `url(${noneImg}) -1257px -85px`,
        marginBottom: '5px',
      }}
    ></i>
    <p
      style={
        {
          color: 'white',
          fontSize: '14PX',
        }
      }
    >{props.text}</p>
  </div>
)

export default NoneData;